import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {TabViewCustom} from '../../../_models/tab-view-custom';

@Component( {
  selector: 'app-flujo-venta-fin-proceso',
  templateUrl: 'flujo-venta-fin-proceso.component.html'
} )

export class FlujoVentaFinProcesoComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() titulo: string;

  constructor() {
  }

  ngOnInit() {
  }
}
